














import Vue from "vue";
import Component from "vue-class-component";

import {
  CustomDialogOptionsBarChart,
  CustomDialogOptionsBarChartBar
} from "../../types";

const BarChartProps = Vue.extend({
  props: {
    options: { type: Object as () => CustomDialogOptionsBarChart }
  }
});

@Component
export default class BarChart extends BarChartProps {
  getHeight(bar: CustomDialogOptionsBarChartBar) {
    const relValue = this.maxBarValue > 0 ? bar.value / this.maxBarValue : 0;
    return {
      height: `${relValue*32}vw`,
      maxHeight: `${relValue*150}px`
    };
  }
  get maxBarValue (): number {
    return Math.max(...this.options.bars.map(bar => bar.value));
  }
}
